var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form-item', {
    attrs: {
      "label": _vm.i18nt('designer.setting.labelWidth')
    }
  }, [_c('el-input', {
    staticClass: "hide-spin-button",
    attrs: {
      "type": "number",
      "min": "0"
    },
    nativeOn: {
      "input": function($event) {
        return _vm.inputNumberHandler.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.optionModel.labelWidth),
      callback: function($$v) {
        _vm.$set(_vm.optionModel, "labelWidth", $$v)
      },
      expression: "optionModel.labelWidth"
    }
  })], 1)
}
var staticRenderFns = []
export default { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0ca12d84","transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/form-designer/setting-panel/property-editor/labelWidth-editor.vue
// module id = null
// module chunks = 